module.exports = __webpack_public_path__ + "img/卫星扫一扫.0d72b50e.png";